module.exports = __webpack_public_path__ + "img/partner.70219a79.svg";